<template>
  <b-container v-bind:class="$mq" class="tx_class" style="text-align: center">
    <b-row no-gutters style="align-items: center">
      <b-col cols=4 class="tx_class_col"><AccountLink v-bind:account="src"   /></b-col>
      <b-col><img src="@/assets/right-arrow.svg" width=15 height=25 /></b-col>
      <b-col cols=2 class="tx_class_col"><CurrencyAmount v-bind:amount="amount" /></b-col>
      <b-col><img src="@/assets/right-arrow.svg" width=15 height=25 /></b-col>
      <b-col cols=4 class="tx_class_col"><AccountLink v-bind:account="dst"   /></b-col>
    </b-row>
  </b-container>
</template>

<script>
import CurrencyAmount from '../CurrencyAmount.vue'
import AccountLink    from '../AccountLink.vue'

var HasTx = require('../../mixins/has_tx')

export default {
  name   : 'PaymentTx',

  mixins : [HasTx],

  components : {
    CurrencyAmount,
    AccountLink
  },

  computed : {
    src : function(){
      return this.tx_obj["Account"];
    },

    dst : function(){
      return this.tx_obj["Destination"];
    },

    amount : function(){
      return this.tx_obj["Amount"];
    }
  }
}
</script>

<style scoped>
.tx_class.sm{
  margin: 3px;
}
</style>
